import { withStyles } from "@material-ui/core";
import { Col, Row } from "antd";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import PostDataController from "../../Controller/PostDataController.js";
import * as Constants from "../../Pages/Constants";

const KidneyBloodForm = (props) => {
  const { classes } = props;
  const [results, setResults] = useState([
    { label: "gfr", value: "0" },
    { label: "creatine", value: "0" },
    { label: "uric_acid", value: "0" },
    { label: "albuminuria_ratio", value: "0" },
    { label: "glucose", value: "0" },
  ]);
  const [peritonealLiquidValue, setPeritonealLiquidValue] = useState("");

  const getResult = (label) => {
    let index = results.findIndex((r) => r.label === label);
    return results[index];
  };

  const sendingForm = async () => {
    let to_send = [...results];
    
    to_send.unshift({ label: "form_type", value: "kidney_blood" });

    // Send data in backend & update display
    let current_Date = new Date();
    // Zero out milliseconds to ensure consistency between backend and frontend
    current_Date.setMilliseconds(0);
    
    await PostDataController.post_observation(current_Date, to_send, "health_form", props.id_patient); // Send data in backend

    await props.update(current_Date, results);

    props.cancelPopup();
  };

  const changeResultValue = (e) => {
    let new_results = [...results];
    let index = new_results.findIndex((r) => r.label === e.target.name);
    new_results[index] = { label: e.target.name, value: e.target.value };
    setResults(new_results);
  };

  const renderInputOneSelect = (message_id, defaultMessage, input_name, select_value, select_change) => {
    return (
      <Row style={{ width: "100%", color: "black", textAlign: "left", padding: "0.3rem" }}>
        <Col style={{ width: "5%" }}></Col>
        <Col style={{ width: "50%" }}>
          <FormattedMessage id={message_id} defaultMessage={defaultMessage} />
        </Col>
        <Col style={{ width: "15%" }}>
          <input style={{ width: "100%" }} type="number" name={input_name} min={0} step={1} precision={1} value={getResult(input_name).value} onChange={(e) => changeResultValue(e)} />
          <br />
        </Col>
        <Col style={{ width: "15%", textAlign: "right" }}></Col>
        <Col style={{ width: "15%", textAlign: "right" }}></Col>
      </Row>
    );
  };

  const generatePageKidneyBlood = () => {
    return (
      <div>
        <Row style={{ fontWeight: "bold", fontSize: "1.5em", color: "black", display: "block", textAlign: "center" }}>
          <FormattedMessage id="kidney.form.blood.title" defaultMessage="Blood test" />
        </Row>
        <br />
        {renderInputOneSelect("kidney.form.blood.one", "GFR (CKD-EPI) ml/min/1.73m", "gfr", 0, changeResultValue)}
        {renderInputOneSelect("kidney.form.blood.two", "Creatinine (mg/l)", "creatine", 0, changeResultValue)}
        {renderInputOneSelect("kidney.form.blood.three", "Uric acid", "uric_acid", 0, changeResultValue)}
        {renderInputOneSelect("kidney.form.blood.four", "Albuminuria ratio", "albuminuria_ratio", 0, changeResultValue)}
        {renderInputOneSelect("kidney.form.blood.five", "Glucose (g/l)", "glucose", 0, changeResultValue)}
      </div>
    );
  };

  let generalFormWidth = "75%";
  if (props.screenSize.width < 800) {
    generalFormWidth = "100%";
  }
  return (
    <div className={classes.popup_background}>
      <div style={{ width: { generalFormWidth }, height: "100%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
        <div className="submit-form" style={{ borderRadius: "5px" }}>
          {generatePageKidneyBlood()}
          <br />
          <button onClick={props.cancelPopup} className="btn btn-danger mx-1">
            <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
          </button>
          <button onClick={sendingForm} className="btn btn-success mx-1">
            <FormattedMessage id="button.submit" defaultMessage="Submit" />
          </button>
        </div>
      </div>
    </div>
  );
};
export default withStyles(Constants.styles)(KidneyBloodForm);
